import { render, staticRenderFns } from "./WordsRoll.vue?vue&type=template&id=0c7b4c2c&scoped=true"
import script from "./WordsRoll.vue?vue&type=script&lang=js"
export * from "./WordsRoll.vue?vue&type=script&lang=js"
import style0 from "./WordsRoll.vue?vue&type=style&index=0&id=0c7b4c2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_cache-lo_875f195a559ab6cb5ed9ea4190ad0331/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c7b4c2c",
  null
  
)

export default component.exports